module.exports = function(bootstrap) {
    bootstrap.run(["Service","sessionData", function (Service, sessionData) {
        return new Service({

            name: 'cancelCoverageStatus',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/employees/v1/subscriberSSN",
            cache: false,

            putInEmp: function(pay){
                this.url += '?transactionType=CANCEL';
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
                return this.put(pay);
            }
        });
    }]);
};
